<template>
    <div class="textCom">
        <input class="text" type="text" v-model="config.centent"
               v-if="config.textType === 'input'"
               placeholder="请在组件配置中输入内容！"
               :style="{
                color:config.color,
                fontFamily:config.fontFamily,
                fontSize:config.fontSize +'px',
                fontWeight:config.fontWeight,
                textAlign:config.align,
                letterSpacing:config.letterSpacing +'px',
                background:config.backgroundColor,
                border:'none'
               }">
        <textarea class="textarea" v-model="config.centent" v-if="config.textType === 'textarea'"
                  placeholder="请在组件配置中输入内容！"
                  :style="{
                color:config.color,
                fontFamily:config.fontFamily,
                fontSize:config.fontSize +'px',
                fontWeight:config.fontWeight,
                textAlign:config.align,
                letterSpacing:config.letterSpacing +'px',
                background:config.backgroundColor,
                border:'none'
               }"></textarea>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/26 3:57 下午
     */
    export default {
        name: 'textComp',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            option: {
                type: Object,
                default: ''
            },
            trans: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {}
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.option.setting.params;
                }
            },
        },
        methods: {},
        mounted() {
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .textCom {
        .text {
            width: 100%;
            height: 100%;
            background: none;
        }

        .textarea {
            width: 100%;
            height: 100%;
            background: none;
        }
    }
</style>
